import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import useNotificationsTable from './useNotificationsTable';
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import config from '../../../config';


const NotificationsTable = ({setErrorSB, setSuccessSB}) => {
    const { t } = useTranslation();
    const [counter, setCounter] = useState(0);

    const { tableData, loading, error } = useNotificationsTable(counter);

    const handleDelete = async (file) => {
        const filename = file.split('/').pop();
        try {
            await axios.delete(`${config.SYNCHROEU_URL}/parosly/api/v1/rules/${filename}`);
            setSuccessSB(true);
            setCounter((c) => c + 1);
        } catch (err) {
            console.error("Error deleting alert", err);
            setErrorSB(true);
        }
    };

    if (loading) {
        return (
            <div className="rawContainerCenteredH">
                <CircularProgress />
            </div>
        );
    }

    if (error) {
        return (
            <MDBox p={3}>
                <MDTypography variant="h6" color="error" gutterBottom>
                    {t("notifications.table.errorPrefix", { error })}
                </MDTypography>
            </MDBox>
        );
    }

    const tableWithActions = {
        ...tableData,
        columns: [
            ...tableData.columns,
            {
                Header: t("common.table.actions"),
                accessor: "actions",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleDelete(row.original.file)}
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                ),
            },
        ],
    };

    return (
        <div className="diagramContainer">
            <div className="scrollable-100">
                <DataTable
                    table={tableWithActions}
                    canSearch
                />
            </div>

        </div>
    );
};

export default NotificationsTable;
